import { render, staticRenderFns } from "./DialogDocumentView.vue?vue&type=template&id=0a46710d"
import script from "./DialogDocumentView.vue?vue&type=script&lang=js"
export * from "./DialogDocumentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports